<template>
    <div class="vtrend-licheng">
        <!-- <Echart :id="'siteVtrendLicheng'" :options="options" :width="width" :height="height"></Echart> -->
        <div :id="id"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts5'
export default {
    props: {
        id: {
            type: String,
            default: ''
        },
        series: {
            type: Array,
            default: () => { return [] }
        },
        xAxis: {
            type: Object,
            default: () => { return {} }
        },
    },
    data() {
        return {
            options: {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                legend: {
                    data: ['换电次数', '国网电价'],
                    textStyle: {
                        color: '#fff'
                    }
                },
                xAxis: [{
                    type: 'category',
                    data: this.xAxis.data,
                    axisLabel: {//x轴文字的配置
                        show: true,
                        fontSize: 20,
                        textStyle: {
                            color: "#fff",
                        }
                    },
                    axisPointer: {
                        type: 'shadow'
                    }
                }],
                yAxis: [
                    {
                        type: 'value',
                        name: '换电次数',
                        nameTextStyle:{//y轴上方单位的颜色
                            color:'#fff'
                        },
                        axisLabel: {//x轴文字的配置
                            show: true,
                            fontSize: 20,
                            textStyle: {
                                color: "#fff",
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ["rgba(255, 255, 255, 0.15)"]
                            }
                        }
                    },
                    {
                        type: 'value',
                        name: '国网电价',
                        nameTextStyle:{//y轴上方单位的颜色
                            color:'#fff'
                        },
                        axisLabel: {//x轴文字的配置
                            show: true,
                            fontSize: 20,
                            textStyle: {
                                color: "#fff",
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ["rgba(255, 255, 255, 0.15)"]
                            }
                        }
                    }
                ],
                series: [
                    {
                        name: '换电次数',
                        type: 'bar',
                        data: this.series[0],
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                { offset: 0, color: '#60F5FF' },
                                { offset: 1, color: '#3FA5FF' }
                           ])
                        },
                    },
                    {
                        name: '国网电价',
                        type: 'line',
                        color: '#43FFB9',
                        data: this.series[1]
                    }
                ]
            }
        }
    },
    mounted() {
        this.myCharts()
    },
    methods: {
        myCharts() {
            const _this = this
            const myCharts = echarts.init(document.getElementById(_this.id))
            myCharts.setOption(_this.options)
        }
    }
}
</script>

<style lang="scss" scoped>
.vtrend-licheng {
    width: 100%;
    height: 100%;
    > div {
        width: 100%;
        height: 100%;
    }
}
</style>